import { bluePalette, grayPalette } from '../../themes/colors';

export const breadcrumbsDarkTheme = {
  link: {
    size: 12,
    fontWeight: 400,
    color: bluePalette[600],
  },
  text: {
    size: 12,
    fontWeight: 600,
    color: grayPalette[100],
  },
};
